<template>
  <div v-if="toggleShow">
    <div class="tw-document-wrapper z-top controls-background">
      <div>
        <div class="card-header bg-white d-flex justify-content-between align-items-center pl-3 pr-2">
          <div class="card-title mb-0 d-flex align-items-center">
            <span class="font-weight-bold">{{ `OTS - ${orderReference || 'Commande'}` }}</span>
          </div>
          <div class="card-title mb-0 d-flex align-items-end">
            <q-icon name="chevron_right" size="20px" @click="toggleShowControls" class="cursor-pointer" />
          </div>
        </div>

        <div class="row card-body tw-document-container">
          <div v-if="loading === true" class="tw-global-spinner z-top position-absolute">
            <q-spinner-facebook size="3em" color="primary" />
          </div>

          <div v-if="loading === false" class="col-12">
            <!-- VIN Info Card -->
            <div class="col-12 mb-3 p-3 bg-light default-border-radius">
              <div class="row">
                <div class="col-3">
                  <label class="d-block mb-0 text-muted font-size-12">VIN / Châssis</label>
                  <span class="font-weight-bold">{{ vin || 'Non renseigné' }}</span>
                </div>
                <div class="col-3">
                  <label class="d-block mb-0 text-muted font-size-12">Commande</label>
                  <span class="font-weight-bold">{{ orderReference || '-' }}</span>
                </div>
                <div class="col-3">
                  <label class="d-block mb-0 text-muted font-size-12">Créé le (e-Flo)</label>
                  <span class="font-weight-bold">{{ createdDate || '-' }}</span>
                </div>
                <div class="col-3">
                  <label class="d-block mb-0 text-muted font-size-12">Vérifié le</label>
                  <span class="font-weight-bold">{{ lastCheckDate || '-' }}</span>
                </div>
              </div>
            </div>

            <!-- No VIN Message -->
            <div v-if="!vin" class="text-deep-black-4 font-weight-normal mt-3">
              <span class="text-warning">⚠️ Aucun VIN renseigné pour ce véhicule.</span>
            </div>

            <!-- No OTS Found -->
            <div v-else-if="otsData && otsData.totalElements === 0" class="text-deep-black-4 font-weight-normal mt-3">
              <span class="text-success">Aucun OTS trouvé pour ce véhicule.</span>
            </div>

            <!-- OTS List -->
            <div v-else-if="otsData && otsData.data && otsData.data.length" class="col-12 pr-2 pl-2 pt-2 default-border-radius">
              <div class="mb-2">
                <span class="font-weight-bold">{{ otsData.totalElements }} OTS trouvé{{ otsData.totalElements > 1 ? 's' : '' }}</span>
              </div>

              <div
                v-for="(ots, index) in otsData.data"
                :key="index"
                class="col-12 p-3 mb-2 ots-item-card"
                :class="getColorClass(ots.colorCode)"
              >
                <div class="row">
                  <!-- Code & Severity -->
                  <div class="col-lg-3 d-flex flex-column">
                    <label class="d-block mb-1 text-muted font-size-11">Code OTS</label>
                    <div class="d-flex align-items-center">
                      <span class="font-size-13 mr-2">{{ getSeverityIcon(ots.colorCode) }}</span>
                      <span class="font-weight-bold">{{ ots.code }}</span>
                    </div>
                  </div>

                  <!-- Label -->
                  <div class="col-lg-9 d-flex flex-column">
                    <label class="d-block mb-1 text-muted font-size-11">Libellé</label>
                    <span class="font-size-13 font-weight-medium">{{ ots.label }}</span>
                  </div>
                </div>

                <!-- Description -->
                <div class="row mt-2">
                  <div class="col-12">
                    <label class="d-block mb-1 text-muted font-size-11">Description / Action</label>
                    <div class="p-2 bg-white default-border-radius border-dashed">
                      <span class="font-size-12">{{ ots.description }}</span>
                    </div>
                  </div>
                </div>

                <!-- Technical Details -->
                <div class="row mt-2">
                  <div class="col-lg-3 d-flex flex-column">
                    <label class="d-block mb-0 text-muted font-size-11">Code Couleur</label>
                    <q-chip
                      :color="getChipColor(ots.colorCode)"
                      text-color="white"
                      size="sm"
                      class="mt-1 ots-color-chip"
                      dense
                    >
                      {{ ots.colorLabel }}
                    </q-chip>
                  </div>

                  <div class="col-lg-3 d-flex flex-column">
                    <label class="d-block mb-0 text-muted font-size-11">Note Technique</label>
                    <span class="font-size-12 font-weight-medium">{{ ots.technicalNoteNumber || '-' }}</span>
                  </div>

                  <div class="col-lg-3 d-flex flex-column">
                    <label class="d-block mb-0 text-muted font-size-11">Quotation</label>
                    <span class="font-size-12 font-weight-medium">{{ ots.quotation || '-' }}</span>
                  </div>

                  <div class="col-lg-3 d-flex flex-column">
                    <label class="d-block mb-0 text-muted font-size-11">Accord Garantie</label>
                    <span class="font-size-12 font-weight-medium">
                      {{ ots.agreement === '1' ? '✓ Oui' : '✗ Non' }}
                    </span>
                  </div>
                </div>

                <!-- Additional Details Row -->
                <div class="row mt-2">
                  <div class="col-lg-6 d-flex flex-column">
                    <label class="d-block mb-0 text-muted font-size-11">Pays de Livraison</label>
                    <span class="font-size-12 font-weight-medium">{{ ots.deliveryCountryCode || '-' }}</span>
                  </div>

                  <div class="col-lg-6 d-flex flex-column">
                    <label class="d-block mb-0 text-muted font-size-11">Date Livraison</label>
                    <span class="font-size-12 font-weight-medium">{{ formatDate(ots.deliveryDate) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import store from "@/store";
import { useRoute } from "vue-router";
import { getOtsSolutionsByVin, getOtsColorClass, getOtsSeverityIcon } from "@/store/services/ots/otsService";
import moment from "moment";

@Options({
  components: {}
})
export default class OtsDialog extends Vue {
  loading: any = true;
  error: string | null = null;
  otsData: any = null;

  get toggleShow() {
    return store.state.orderModule.showOts;
  }

  toggleShowControls() {
    return store.dispatch('orderModule/toggleShowOts');
  }

  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }

  get reference() {
    switch (this.currentRoute) {
      case "order-edit":
        return store.state.orderModule.order?.reference;
      case "TaskDetail":
        return store.state.taskModule.order?.reference;
    }
    return "-";
  }

  get order() {
    if (this.currentRoute === 'TaskDetail') {
      return store.state.taskModule.order;
    } else {
      return store.state.orderModule.order;
    }
  }

  get vin(): string {
    const order = this.order;
    console.log("OtsDialog - Order:", order);
    if (order && order.orderItems && order.orderItems.length > 0) {
      const orderItem = order.orderItems[0];
      console.log("OtsDialog - OrderItem:", orderItem);
      if (orderItem.orderAssets && orderItem.orderAssets.length > 0) {
        const chassisRef = orderItem.orderAssets[0]?.chassisReference || "";
        console.log("OtsDialog - VIN found:", chassisRef);
        return chassisRef;
      }
    }
    console.log("OtsDialog - No VIN found");
    return "";
  }

  get orderReference(): string {
    return this.reference;
  }

  get lastCheckDate(): string {
    // Date de dernière vérification depuis les métadonnées de réponse
    // Pour l'instant, date actuelle (sera remplacée par cache)
    return moment().format('DD/MM/YYYY HH:mm');
  }

  get createdDate(): string {
    // Date de première vérification (sera remplie par cache)
    return moment().format('DD/MM/YYYY HH:mm');
  }

  get orderId(): string {
    return this.order?.resourceUid || '';
  }

  formatDate(date?: string) {
    if (!date) return '-';
    return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }

  formatDateTime(date?: string) {
    if (!date) return '-';
    return moment(date).format('DD/MM/YYYY HH:mm');
  }

  async loadOtsData() {
    this.loading = true;
    this.error = null;
    this.otsData = null;

    try {
      console.log("Loading OTS for VIN:", this.vin, "OrderID:", this.orderId);
      this.otsData = await getOtsSolutionsByVin(this.vin, {
        locale: "fr_FR",
        orderId: this.orderId,  // Pass orderId for cache
        useCache: true          // Enable caching
      });
      console.log("OTS Data received:", this.otsData);

      // If no OTS found, close the dialog and notify user
      if (!this.otsData || this.otsData.totalElements === 0) {
        (this as any).$q.notify({
          message: 'Aucun OTS trouvé pour ce véhicule',
          color: 'positive',
          icon: 'check_circle'
        });
        this.toggleShowControls(); // Close dialog
      }
    } catch (err: any) {
      console.error("Error loading OTS:", err);
      this.error = err.message || "Erreur lors du chargement des OTS";

      // Show error notification
      (this as any).$q.notify({
        message: this.error,
        color: 'negative',
        icon: 'error',
        timeout: 20000
      });

      // Close dialog on error
      this.toggleShowControls();
    } finally {
      this.loading = false;
    }
  }

  getColorClass(colorCode: string): string {
    const classMap: { [key: string]: string } = {
      'R': 'ots-critical',
      'O': 'ots-important',
      'J': 'ots-warning',
      'B': 'ots-info',
      'V': 'ots-normal',
      'I': 'ots-general',
      'S': 'ots-special'
    };
    return classMap[colorCode] || 'ots-general';
  }

  getSeverityIcon(colorCode: string): string {
    return getOtsSeverityIcon(colorCode);
  }

  getChipColor(colorCode: string): string {
    const colorMap: { [key: string]: string } = {
      R: "red",
      O: "orange",
      J: "yellow-9",
      B: "blue",
      V: "green",
      I: "grey",
      S: "purple",
    };
    return colorMap[colorCode] || "grey";
  }

  async created() {
    this.loading = true;
    if (this.vin) {
      await this.loadOtsData();
    } else {
      this.loading = false;
    }
  }
}
</script>

<style scoped lang="scss">
.controls-background {
  background-color: white;
  border-radius: 10px;
  -webkit-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 3px 3px 15px -4px rgba(0, 0, 0, 0.75);
  overflow-y: auto;
}

.ots-item-card {
  background: white;
  border: 2px solid;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  &.ots-critical {
    border-color: #f443367d;
    background-color: #ffebee8f;
  }

  &.ots-important {
    border-color: #ff9800;
    background-color: #fff3e0;
  }

  &.ots-warning {
    border-color: #ffc107;
    background-color: #fffde7;
  }

  &.ots-info {
    border-color: #2196f3;
    background-color: #e3f2fd;
  }

  &.ots-normal {
    border-color: #4caf50;
    background-color: #e8f5e9;
  }

  &.ots-general {
    border-color: #9e9e9e;
    background-color: #f5f5f5;
  }

  &.ots-special {
    border-color: #9c27b0;
    background-color: #f3e5f5;
  }
}

.border-dashed {
  border: 1px dashed #3699FF;
}

.font-size-11 {
  font-size: 11px;
}

.font-size-12 {
  font-size: 12px;
}

.font-size-13 {
  font-size: 13px;
}

.font-size-20 {
  font-size: 20px;
}

.font-weight-medium {
  font-weight: 500;
}

.ots-color-chip {
  font-size: 10px !important;
  width: fit-content !important;
  min-width: auto !important;
  padding: 2px 8px !important;
  height: auto !important;
}
</style>
